

// export const baseURL= "http://192.168.29.250:7002/api/"
// export const baseURLImg= "http://192.168.29.250:7002/api"

export const baseURL= "https://dignosticcenter-service.swasthyakhata.com/api/"
export const baseURLImg= "https://dignosticcenter-service.swasthyakhata.com/api"

export const auth={
    checkUserByAdhaar:baseURL+'dignosticcenter/checkUserByAadhaar',
    sendOtp:baseURL+'dignosticcenter/send-otp',
    loginDoctor:baseURL+'dignosticcenter/login',
    createDoctor:baseURL+'dignosticcenter/create'
}

export const doctors={
    requestDoctor:baseURL+'dignosticcenter/diagnostic-center-request-doctor-for-mapping',
    getAllDoctors:baseURL+'dignosticcenter/get-all-doctors-for-diagnostic-center',
    requestFromdoctors:baseURL+'dignosticcenter/mapping-requests/from-doctor'
}

export const hospitals={
    requestsFromHospitals:baseURL+'dignosticcenter/hospital-diagnostic-center-mapping-requests/by-diagnostic-center-id',
    getAllHospitals:baseURL+'dignosticcenter/get-all-hospitals-for-diagnostic-center'
}